import styled from "styled-components";

export const CreatePageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60%;
    height: 100%;
    padding-top: 2rem;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 80%;
        padding: 1rem;
    `}

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
        padding: 1rem;
    `}
    
`;

export const CreatePageInner = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: calc(100% - 2rem);
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
    `}
`;

export const CreatePagePreview = styled.div`
    flex: 1;
`;

export const CreatePageForm = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
    margin-left: 2rem;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        margin-left: 0;
    `}

    form {
        width: calc(100% - 2rem);
        padding-bottom: 2rem;

        img, video {
            max-height: 300px;
        }
    }
`;

export const PageSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin: 1rem 0;
`;

export const PageSectionTitle = styled.div`
    width: 100%;
    height: 3rem;
    font-size: 1.2rem;
    font-weight: 500;
`;

export const PageSectionContent = styled.div`
    width: 100%;
    height: auto;
`;

export const PropertySection = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 1rem;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
    `}
`;

export const PropertySectionItem = styled.div`
    flex: 1;
    margin: 0 1rem;
`;